import { LOCALES } from 'utils/languageUtils';

/** @type {Readonly<Record<LOCALES.ENGLISH | LOCALES.GREEK, Record<string, string>>>} */
const ROAMING_PRODUCT_LABELS = Object.freeze({
  [LOCALES.ENGLISH]: {
    from: 'From',
    free: 'Free',
    priceSuffix: {
      daily: '/day',
      weekly: '/week',
      monthly: '/month',
      yearly: '/year',
    },
    activateOn: 'Activate it via',
    buttonLabel: 'Telekom App',
  },
  [LOCALES.GREEK]: {
    from: 'Από',
    free: 'Δωρεάν',
    priceSuffix: {
      daily: '/ημέρα',
      weekly: '/εβδομάδα',
      monthly: '/μήνα',
      yearly: '/χρόνο',
    },
    activateOn: 'Ενεργοποίησέ το μέσω',
    buttonLabel: 'Telekom App',
  },
});
export default ROAMING_PRODUCT_LABELS;
